import { SuretyAccountPreview } from "@portal/api/account/agent";
import { useFetchAccountPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { FC, useMemo } from "react";
import { accountsTableColumns } from "./columns";

type WrittenAccountFilter = (account: SuretyAccountPreview) => boolean;

export const createWrittenAccountPreviews = (
	tableName: string,
	filterPredicate: WrittenAccountFilter,
): FC => {
	const WrittenAccountPreviews: FC = () => {
		const { accountPreviews } = useFetchAccountPreviews();

		const data = useMemo(() => {
			if (!accountPreviews) return undefined;
			return accountPreviews.filter(filterPredicate);
		}, [accountPreviews]);

		return (
			<FilterableDataTable
				name={tableName}
				columnDefs={accountsTableColumns}
				getRowUrl={(row) => `/accounts/${row.id}`}
				data={data}
				loadingMessage="Loading accounts..."
				enableExportToCSV
			/>
		);
	};

	return WrittenAccountPreviews;
};
